import { Input } from '@/lib';
import { Button } from '@/lib/Buttons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { DEFAULT_TITLE_STYLES } from './EditableTitleView.styles';

type EditableTitleEditProps = {
  initialValue: string;
  onSave: (value: string) => Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
  className?: string;
};


export function EditableTitleEdit({ initialValue, onSave, onCancel, isLoading = false, className }: EditableTitleEditProps) {
  const { t } = useTranslation();
  const [editValue, setEditValue] = useState(initialValue);

  const handleKeyPress = (e: React.KeyboardEvent) => {
    switch (e.key) {
      case 'Enter':
        handleSave();
        break;
      case 'Escape':
        onCancel();
        break;
    }
  };

  const handleSave = async () => {
    if (editValue.trim()) {
      await onSave(editValue.trim());
    }
  };

  return (
    <div className='flex items-center gap-2'>
      <Input
        value={editValue}
        onChange={(e) => setEditValue(e.target.value)}
        onKeyDown={handleKeyPress}
        className={twMerge(DEFAULT_TITLE_STYLES, className)}
        autoFocus
      />
      <Button
        onClick={handleSave}
        isLoading={isLoading}
        disabled={!editValue.trim() || editValue.trim() === initialValue}
        intent='primary'
        text={t('ALL:save')}
      />
      <Button onClick={onCancel} intent='secondary' text={t('ALL:cancel')} />
    </div>
  );
}